import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuthStore } from "@/store/useAuthStore";

export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const token = useAuthStore((state) => state.token);
  const hasHydrated = useAuthStore((state) => state.hasHydrated);

  useEffect(() => {
    if (!hasHydrated) return;
    if (!token) {
      const next = pathname ? `?next=${encodeURIComponent(pathname)}` : "";
      navigate(`/login${next}`, { replace: true });
    }
  }, [hasHydrated, token, navigate, pathname]);

  if (!hasHydrated) return null;
  if (!token) return null;

  return <>{children}</>;
}
